export default "/bg/sm/land5.jpg"